import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Cancel';
import { showMessage } from 'app/store/fuse/messageSlice';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import AdatlapService from '../service/AdatlapService';

function FeltoltesAdatlapCloseButton(props) {
	const [showConfirm, setShowConfirm] = useState(false);
	const dispatch = useDispatch();

	const onClose = () => {
		AdatlapService.closeFolder(props.item.csomagNev, props.button.paperType, props.item.vizsgaAdatlap).then(resp => {
			if (resp) {
				dispatch(showMessage({ message: 'Sikeres lezárás.' }));
				dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
			} else {
				dispatch(showMessage({ message: 'Hiba történt a lezárás végrehajtása során.' }));
			}
		});
		console.log(props.item);
	};

	return (
		<TableCell className="w-auto text-center" padding="none">
			<Tooltip title="Lezárás">
				<span>
					<IconButton
						aria-label="delete"
						onClick={e => {
							setShowConfirm(true);
							e.preventDefault();
						}}
						disabled={props.item && props.item.protectionLevel && (props.item.protectionLevel === 'CannotBeDeleted' || props.item.protectionLevel === 'CannotBeModified')}
					>
						<CloseIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
			<ConfirmDialog show={showConfirm} title="Lezárás" description="Biztosan lezárja a kiválasztott tételt?" onYes={() => onClose()} onClose={() => setShowConfirm(false)} />
		</TableCell>
	);
}

export default FeltoltesAdatlapCloseButton;
